export const SHORT_TIMEOUT = 20000
export const MEDIUM_TIMEOUT = 30000
export const LONG_TIMEOUT = 60000
